import {
  Card,
  CardBody,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  CardHeader,
  CardTitle,
} from "reactstrap";
import { useState, React, useEffect, useRef, useContext } from "react";
import { NavLink, useHistory } from "react-router-dom";
import "moment-timezone";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingOverlay from "react-loading-overlay";
import { MainContext } from "context/MainContext.js";
LoadingOverlay.propTypes = undefined;

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";

const FirmwareUpload = () => {
  const history = useHistory();

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["firmwares.upload.display"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }
  }, []);

  const [showLoading, setShowLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState([]);

  const [files, setFiles] = useState([]);
  const [uploadBtnEnabled, setUploadBtnEnabled] = useState(false);

  const inputFileRef = useRef(null);
  const privileges = useContext(MainContext);

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);

    if (selectedFiles == undefined || selectedFiles.length == 0) {
      setUploadBtnEnabled(false);
    } else {
      setUploadBtnEnabled(true);
    }

    setFiles(selectedFiles);
  };

  const handleUpload = () => {
    setShowLoading(true);

    const formData = new FormData();
    files.forEach((file) => {
      formData.append("files", file);
    });

    fetch("/api/v1/firmware/upload", {
      method: "POST",
      headers: {
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        setFiles([]);
        inputFileRef.current.value = null;
        setUploadBtnEnabled(false);

        if (actualData.status != "200") {
          setErrorMsg(actualData.error_code);
          toast.error("A problem occured while uploading the firmware", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          setErrorMsg([]);
          toast.success("Firmware uploaded successfully", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        }
      })
      .catch((error) => {
        setShowLoading(false);
        setFiles([]);
        inputFileRef.current.value = null;
        setUploadBtnEnabled(false);
        console.log(error.message);
      });
  };

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </NavLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>Add Version</BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Upload</CardTitle>
              </CardHeader>
              <CardBody>
                {errorMsg && errorMsg.length > 0 ? (
                  <div
                    style={{
                      backgroundColor: "#FFC0A4",
                      border: "1px solid #ef8157",
                      color: "#66615b",
                      paddingTop: "15px",
                      marginBottom: "15px",
                    }}
                  >
                    <ul>
                      {errorMsg.map((d, index) => (
                        <li key={index}>{d}</li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
                <Row>
                  <Col>
                    This section allows you to upload new firmware. Make sure to
                    include all the files of the version at the same time.
                  </Col>
                </Row>
                <Row style={{ marginTop: "25px", marginBottom: "25px" }}>
                  <Col>
                    <div>
                      <input
                        type="file"
                        multiple
                        onChange={handleFileChange}
                        ref={inputFileRef}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div>
                      <button
                        onClick={handleUpload}
                        disabled={!uploadBtnEnabled}
                      >
                        Upload
                      </button>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default FirmwareUpload;
